import "./footer.css";

const Footer = () => {
  return <div className="footer">Ⓒ 2023 #VANLIFE #AH</div>;
};

export default Footer;
